var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 91,
    viewBox: "0 0 108 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8264_81622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 28.5C32 20.768 38.268 14.5 46 14.5H62C69.732 14.5 76 20.768 76 28.5V44.5C76 52.232 69.732 58.5 62 58.5H46C38.268 58.5 32 52.232 32 44.5V28.5Z",
    fill: "url(#paint0_linear_8264_81622)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8264_81622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 28.5C32 20.768 38.268 14.5 46 14.5H62C69.732 14.5 76 20.768 76 28.5V44.5C76 52.232 69.732 58.5 62 58.5H46C38.268 58.5 32 52.232 32 44.5V28.5Z",
    fill: "url(#paint1_linear_8264_81622)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8264_81622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 46.5C59.5228 46.5 64 42.0228 64 36.5C64 30.9772 59.5228 26.5 54 26.5C48.4772 26.5 44 30.9772 44 36.5C44 42.0228 48.4772 46.5 54 46.5Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 36.5L53 38.5L57 34.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8264_81622)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8264_81622",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 18.5C66 15.1863 68.6863 12.5 72 12.5C75.3137 12.5 78 15.1863 78 18.5C78 21.8137 75.3137 24.5 72 24.5C68.6863 24.5 66 21.8137 66 18.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 18.5C66 15.1863 68.6863 12.5 72 12.5C75.3137 12.5 78 15.1863 78 18.5C78 21.8137 75.3137 24.5 72 24.5C68.6863 24.5 66 21.8137 66 18.5Z",
    fill: "url(#paint2_linear_8264_81622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 18.5M78 18.5M78 18.5M66 18.5M72 12.5M78 18.5M72 24.5M66 18.5M72 24.5V22.5C69.7909 22.5 68 20.7091 68 18.5H66H64C64 22.9183 67.5817 26.5 72 26.5V24.5ZM78 18.5H76C76 20.7091 74.2091 22.5 72 22.5V24.5V26.5C76.4183 26.5 80 22.9183 80 18.5H78ZM72 12.5V14.5C74.2091 14.5 76 16.2909 76 18.5H78H80C80 14.0817 76.4183 10.5 72 10.5V12.5ZM72 12.5V10.5C67.5817 10.5 64 14.0817 64 18.5H66H68C68 16.2909 69.7909 14.5 72 14.5V12.5Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8264_81622)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8264_81622",
    x: 0,
    y: -17.5,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8264_81622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8264_81622",
    x: 20,
    y: 12.5,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81622",
    result: "effect2_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8264_81622",
    x: 54,
    y: 10.5,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81622",
    result: "effect2_dropShadow_8264_81622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8264_81622",
    x1: 32,
    y1: 14.5,
    x2: 76,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8264_81622",
    x1: 32,
    y1: 14.5,
    x2: 76,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8264_81622",
    x1: 66,
    y1: 12.5,
    x2: 78,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8264_81622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(42 24.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteOrders);
export default __webpack_public_path__ + "static/media/Complete Orders.2d9650a74777e014c904e6d10f82bf11.svg";
export { ForwardRef as ReactComponent };